import { lampAppearanceSpecs, renderLightBulb } from "apparatus/library/lamp";
import { Mounted } from "apparatus/library/physics/electric/mounted/utils";
import { Group } from "paper";
export class MountedBulb {
    render(appearance) {
        const { base, jacks, snaps } = Mounted.renderPlate({ appearance, width: 80 });
        const lampGraphic = renderLightBulb(appearance, "3d");
        lampGraphic.position.x += 35;
        lampGraphic.position.y += -17;
        const graphic = new Group([base, jacks, lampGraphic]);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            pivot: base.bounds.center,
            snapping: [...snaps]
        };
    }
}
MountedBulb.properties = {
    label: "Bulb",
    defaultAppearance: Object.assign(Object.assign({}, Mounted.defaultAppearance), { color: "yellow", glow: "small", on: false, scale: 1 }),
    appearanceSpecs: [
        ...Mounted.appearanceSpecs,
        ...lampAppearanceSpecs,
    ],
};
